import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ThemMoiTaiSan2 } from "components/CommonComponent/ThemMoiTaiSan/index2";

export const BtnSua = ({ TaiSanID }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Sửa"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-sua-v3.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ThemMoiTaiSan2 show={show} onHide={handleClose} TaiSanID={TaiSanID} />
      )}
    </>
  );
};
